// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__Q4wrg","head":"Table_head__1mrJd","col":"Table_col__2b3AR"};